var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5176 15.0176H3.51758C2.68915 15.0176 2.01758 14.346 2.01758 13.5176V4.45233C2.05253 3.64949 2.71398 3.01682 3.51758 3.01758H15.5176C16.346 3.01758 17.0176 3.68915 17.0176 4.51758V13.5176C17.0176 14.346 16.346 15.0176 15.5176 15.0176ZM3.51758 5.91858V13.5176H15.5176V5.91858L9.51758 9.91758L3.51758 5.91858ZM4.11758 4.51758L9.51758 8.11758L14.9176 4.51758H4.11758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d90caf5d4da7e69cbad6a9c31b17f064.svg";
export { ForwardRef as ReactComponent };